<mat-card appearance="outlined" class="resource-page">
  <mat-card-header>
  <mat-card-title>Compute @if (selectedGroup?.group) {
    <span> > Groupe : {{selectedGroup.group}}</span>
    }@if (dataSource) {
    <span
    >({{dataSource.length}})</span>
  }</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    @if (!loading) {
      <div>
        <!-- Conteneur pour le tableau responsive -->
        <div class="datatable table-scroll" role="region" aria-label="Instances EC2" tabindex="0">
          @if (user_groups.length > 0) {
          <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
            @for (group of user_groups; track group) {
              <mat-tab [label]="group">{{group}}</mat-tab>
            }
          </mat-tab-group>
          }
          @if (all || selectedGroup?.group) {
            <table mat-table [dataSource]="dataSource"
              matSort matSortActive="name" matSortDisableClear matSortDirection="asc">
              <!-- Colonne State -->
              <ng-container matColumnDef="state">
                <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true" class="col-stretch-l">État
                </th>
                <td mat-cell *matCellDef="let resource" disableClear="true" class="col-stretch-xl">
                  <span class="resource-state-cell">
                    <span class="resource-state" [ngClass]="getDisplayedResourceState(resource)" role="status" aria-live="polite">
                      <mat-icon aria-hidden="true">{{ getResourceStateDesc(getDisplayedResourceState(resource))?.icon }}</mat-icon>
                      <span>{{ getResourceStateLabel(getDisplayedResourceState(resource)) }}</span>
                    </span>
                    <small class="resource-state-date">
                      @if (resource.stateChangedAt) {
                        Dernier changement : {{ resource.stateChangedAt | date: 'dd/MM/yyyy HH:mm' }}
                      } @else {
                        Historique indisponible
                      }
                    </small>
                  </span>
                </td>
              </ng-container>
              <!-- Colonne Name -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true">Nom</th>
                <td mat-cell *matCellDef="let resource" class="col-stretch-xl">{{ resource['name'] }}</td>
              </ng-container>
              <!-- Colonne Application -->
              <ng-container matColumnDef="application">
                <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true">Application</th>
                <td mat-cell *matCellDef="let resource" class="col-stretch-xl">{{ resource['application'] }}
                </td>
              </ng-container>
              <!-- Colonne Region -->
              <ng-container matColumnDef="region">
                <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true">Région</th>
                <td mat-cell *matCellDef="let resource" class="col-stretch-xl">{{ resource['region'] }}</td>
              </ng-container>
              <!-- Colonne Instance Id -->
              <ng-container matColumnDef="instanceId">
                <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true">Instance Id</th>
                <td mat-cell *matCellDef="let resource" class="col-stretch-xl">{{ resource['instanceId'] }}</td>
              </ng-container>
              <!-- Colonne Actions -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let resource">
                  <!-- Conteneur pour les boutons alignés -->
                  <div class="action-buttons">
                    <!-- Boucle sur les actions applicables à la ressource -->
                    @for (action of getApplicableActions(resource); track action) {
                      <button mat-icon-button [color]="action.color"
                        [matTooltip]="action.name === 'start' ? 'Démarrer' : 'Arrêter'"
                        [attr.aria-label]="(action.name === 'start' ? 'Démarrer ' : 'Arrêter ') + resource.name"
                        (click)="action.handler($event, resource)">
                        <mat-icon>{{ action.icon }}</mat-icon>
                      </button>
                    }
                  </div>
                </td>
              </ng-container>
              <!-- Lignes du tableau -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row class="caaks-detail-row"
              *matRowDef="let row; columns: displayedColumns; let index = index"></tr>
            </table>
          } @else {
            <div class="page-status">
              <mat-icon>error</mat-icon>
              <span>Veuillez sélectionner un groupe.</span>
            </div>
          }
        </div>
        @if (dataSource && dataSource.length === 0) {
          <p class="page-status">Aucune instance.</p>
        }
      </div>
    } @else {
      <div class="page-status" role="status">
        <mat-spinner [diameter]="32"></mat-spinner>
        <span>Chargement des données...</span>
      </div>
    }

  </mat-card-content>
</mat-card>